/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNotification } from '@/containers'
import { useClickOutsideComponent } from '@/utils/useClickOutsideComponent'
import DrawChat from '../DrawChat'
import { IconChat } from '../Icon/IconChat'
import { IconChatClose } from '../Icon/IconChatClose'
import { IconHotLine } from '../Icon/IconHotLine'
import { IconMessenger } from '../Icon/IconMessenger'
import { IconZalo } from '../Icon/IconZalo'

export function PopupChat() {
  const { systemConfig } = useNotification()
  const { ref, isComponentVisible, setIsComponentVisible } =
    useClickOutsideComponent(false)
  return (
    <>
      <DrawChat
        refer={ref || null}
        open={isComponentVisible}
        onClose={() => setIsComponentVisible(false)}
      >
        <div className='flex absolute flex-col gap-y-3 right-1 text-sm pb-28 h-full justify-end'>
          <a
            href={systemConfig?.companyZalo}
            target='_blank'
            className='zalo flex items-center justify-end'
          >
            <span className='mr-1 font-bold text-white-400'>Zalo</span>
            <span className='bg-blue-400 p-2.5 rounded-full'>
              <IconZalo />
            </span>
          </a>
          <a
            href={systemConfig?.companyMessenger}
            target='_blank'
            className='messenger flex  items-center justify-end'
          >
            <span className='mr-1 font-bold text-white-400'>Messenger</span>
            <IconMessenger />
          </a>
          {/* <a
            href='#nogo'
            onClick={() => (window as any).subiz('expandWidget')}
            className='subiz flex items-center justify-end'
          >
            <span className='mr-1 font-bold text-white-400'>Chat ngay</span>
            <IconChat />
          </a> */}
          <a
            href={`tel:${systemConfig?.companyHotline1?.trim()}`}
            className='messenger flex items-center justify-end'
          >
            <p className='mr-1 font-bold text-white-400 flex flex-col text-right'>
              <span>{systemConfig?.companyHotlineText1?.trim()}</span>
              <span className='font-bold text-white-400'>
                {systemConfig?.companyHotline1}
              </span>
            </p>
            <IconHotLine />
          </a>
          <a
            href={`tel:${systemConfig?.companyHotline2?.trim()}`}
            className='messenger flex items-center justify-end'
          >
            <p className='mr-1 font-bold text-white-400 flex flex-col text-right'>
              <span>{systemConfig?.companyHotlineText2?.trim()}</span>
              <span className='font-bold text-white-400'>
                {systemConfig?.companyHotline2}
              </span>
            </p>
            <IconHotLine />
          </a>
        </div>
      </DrawChat>
      <div
        onClick={() => setIsComponentVisible(true)}
        className='block z-[999] fixed bottom-16 right-1'
      >
        {isComponentVisible ? <IconChatClose /> : <IconChat />}
      </div>
    </>
  )
}

export default PopupChat
